import {
  User,
  Users,
  UserCircle,
  UserCheck,
  UserPlus,
  Contact,
  PersonStanding,
  Baby,
  Accessibility,
  HeartHandshake,
  Building,
  Building2,
  Warehouse,
  Factory,
  Store,
  Hotel,
  Hospital,
  School,
  Church,
  Landmark,
  Server,
  Monitor,
  Laptop,
  Smartphone,
  Tablet,
  Cpu,
  HardDrive,
  Wifi,
  Cloud,
  Database,
  Shield,
  ShieldCheck,
  ShieldAlert,
  Lock,
  LockOpen,
  Key,
  KeyRound,
  Fingerprint,
  ScanFace,
  Eye,
  Mail,
  MessageSquare,
  MessageCircle,
  Phone,
  PhoneCall,
  Video,
  Megaphone,
  Bell,
  BellRing,
  Send,
  Network,
  Workflow,
  GitMerge,
  Share2,
  Link,
  Layers,
  LayoutGrid,
  LayoutList,
  Kanban,
  Trello,
  File,
  FileText,
  FileCode,
  FileCog,
  Folder,
  FolderOpen,
  Clipboard,
  ClipboardList,
  Archive,
  Package,
  CheckCircle,
  XCircle,
  AlertCircle,
  AlertTriangle,
  Info,
  HelpCircle,
  Clock,
  Timer,
  Activity,
  Zap,
  Globe,
  Map,
  MapPin,
  Compass,
  Flag,
  Bookmark,
  Star,
  Heart,
  Award,
  Trophy,
  Settings,
  Wrench,
  Hammer,
  SlidersHorizontal,
  Filter,
  Bot,
  Briefcase,
  Wand2,
  Palette,
  Pen,
  icons,
  type LucideIcon,
} from 'lucide-react'

// ============================================================
// Icon categories (10 categories × 10 icons each = 100 quick-picks)
// ============================================================

export const ICON_CATEGORIES: { key: string; icons: { name: string; icon: LucideIcon }[] }[] = [
  {
    key: 'people',
    icons: [
      { name: 'User', icon: User },
      { name: 'Users', icon: Users },
      { name: 'UserCircle', icon: UserCircle },
      { name: 'UserCheck', icon: UserCheck },
      { name: 'UserPlus', icon: UserPlus },
      { name: 'Contact', icon: Contact },
      { name: 'PersonStanding', icon: PersonStanding },
      { name: 'Baby', icon: Baby },
      { name: 'Accessibility', icon: Accessibility },
      { name: 'HeartHandshake', icon: HeartHandshake },
    ],
  },
  {
    key: 'business',
    icons: [
      { name: 'Building', icon: Building },
      { name: 'Building2', icon: Building2 },
      { name: 'Warehouse', icon: Warehouse },
      { name: 'Factory', icon: Factory },
      { name: 'Store', icon: Store },
      { name: 'Hotel', icon: Hotel },
      { name: 'Hospital', icon: Hospital },
      { name: 'School', icon: School },
      { name: 'Church', icon: Church },
      { name: 'Landmark', icon: Landmark },
    ],
  },
  {
    key: 'technology',
    icons: [
      { name: 'Server', icon: Server },
      { name: 'Monitor', icon: Monitor },
      { name: 'Laptop', icon: Laptop },
      { name: 'Smartphone', icon: Smartphone },
      { name: 'Tablet', icon: Tablet },
      { name: 'Cpu', icon: Cpu },
      { name: 'HardDrive', icon: HardDrive },
      { name: 'Wifi', icon: Wifi },
      { name: 'Cloud', icon: Cloud },
      { name: 'Database', icon: Database },
    ],
  },
  {
    key: 'security',
    icons: [
      { name: 'Shield', icon: Shield },
      { name: 'ShieldCheck', icon: ShieldCheck },
      { name: 'ShieldAlert', icon: ShieldAlert },
      { name: 'Lock', icon: Lock },
      { name: 'LockOpen', icon: LockOpen },
      { name: 'Key', icon: Key },
      { name: 'KeyRound', icon: KeyRound },
      { name: 'Fingerprint', icon: Fingerprint },
      { name: 'ScanFace', icon: ScanFace },
      { name: 'Eye', icon: Eye },
    ],
  },
  {
    key: 'communication',
    icons: [
      { name: 'Mail', icon: Mail },
      { name: 'MessageSquare', icon: MessageSquare },
      { name: 'MessageCircle', icon: MessageCircle },
      { name: 'Phone', icon: Phone },
      { name: 'PhoneCall', icon: PhoneCall },
      { name: 'Video', icon: Video },
      { name: 'Megaphone', icon: Megaphone },
      { name: 'Bell', icon: Bell },
      { name: 'BellRing', icon: BellRing },
      { name: 'Send', icon: Send },
    ],
  },
  {
    key: 'organization',
    icons: [
      { name: 'Network', icon: Network },
      { name: 'Workflow', icon: Workflow },
      { name: 'GitMerge', icon: GitMerge },
      { name: 'Share2', icon: Share2 },
      { name: 'Link', icon: Link },
      { name: 'Layers', icon: Layers },
      { name: 'LayoutGrid', icon: LayoutGrid },
      { name: 'LayoutList', icon: LayoutList },
      { name: 'Kanban', icon: Kanban },
      { name: 'Trello', icon: Trello },
    ],
  },
  {
    key: 'files',
    icons: [
      { name: 'File', icon: File },
      { name: 'FileText', icon: FileText },
      { name: 'FileCode', icon: FileCode },
      { name: 'FileCog', icon: FileCog },
      { name: 'Folder', icon: Folder },
      { name: 'FolderOpen', icon: FolderOpen },
      { name: 'Clipboard', icon: Clipboard },
      { name: 'ClipboardList', icon: ClipboardList },
      { name: 'Archive', icon: Archive },
      { name: 'Package', icon: Package },
    ],
  },
  {
    key: 'status',
    icons: [
      { name: 'CheckCircle', icon: CheckCircle },
      { name: 'XCircle', icon: XCircle },
      { name: 'AlertCircle', icon: AlertCircle },
      { name: 'AlertTriangle', icon: AlertTriangle },
      { name: 'Info', icon: Info },
      { name: 'HelpCircle', icon: HelpCircle },
      { name: 'Clock', icon: Clock },
      { name: 'Timer', icon: Timer },
      { name: 'Activity', icon: Activity },
      { name: 'Zap', icon: Zap },
    ],
  },
  {
    key: 'objects',
    icons: [
      { name: 'Globe', icon: Globe },
      { name: 'Map', icon: Map },
      { name: 'MapPin', icon: MapPin },
      { name: 'Compass', icon: Compass },
      { name: 'Flag', icon: Flag },
      { name: 'Bookmark', icon: Bookmark },
      { name: 'Star', icon: Star },
      { name: 'Heart', icon: Heart },
      { name: 'Award', icon: Award },
      { name: 'Trophy', icon: Trophy },
    ],
  },
  {
    key: 'tools',
    icons: [
      { name: 'Settings', icon: Settings },
      { name: 'Wrench', icon: Wrench },
      { name: 'Hammer', icon: Hammer },
      { name: 'SlidersHorizontal', icon: SlidersHorizontal },
      { name: 'Filter', icon: Filter },
      { name: 'Bot', icon: Bot },
      { name: 'Briefcase', icon: Briefcase },
      { name: 'Wand2', icon: Wand2 },
      { name: 'Palette', icon: Palette },
      { name: 'Pen', icon: Pen },
    ],
  },
]

export const ICON_MAP: Record<string, LucideIcon> = Object.fromEntries(
  ICON_CATEGORIES.flatMap(({ icons: catIcons }) => catIcons.map(({ name, icon }) => [name, icon]))
)

export function resolveEntityTypeIcon(name: string | null | undefined): LucideIcon | null {
  if (!name) return null
  if (ICON_MAP[name]) return ICON_MAP[name]
  const dynamicIcon = icons[name as keyof typeof icons] as LucideIcon | undefined
  return dynamicIcon ?? null
}

/**
 * Resolve the Lucide icon configured on a `TypeValue.settings.icon` for the
 * given `code`, falling back to the provided default when:
 *   - `code` is null/undefined
 *   - no matching `TypeValue` is found
 *   - the matching `TypeValue` has no `settings.icon` set
 *   - `settings.icon` is a non-null string but not resolvable via `resolveEntityTypeIcon`
 *
 * Silent fallback: never throws, never logs — callers always receive a renderable icon.
 */
export function resolveTypeValueIcon(
  typeValues: ReadonlyArray<{code: string; settings?: Record<string, unknown> | null}>,
  code: string | null | undefined,
  fallback: LucideIcon,
): LucideIcon {
  if (!code) return fallback
  const match = typeValues.find(tv => tv.code === code)
  if (!match) return fallback
  const iconName = match.settings && typeof match.settings.icon === 'string'
    ? match.settings.icon
    : null
  if (!iconName) return fallback
  return resolveEntityTypeIcon(iconName) ?? fallback
}

export interface EntityTypeIconProps {
  iconName?: string | null
  className?: string
}

export function EntityTypeIcon({ iconName, className }: EntityTypeIconProps) {
  const Icon = resolveEntityTypeIcon(iconName)
  if (!Icon) return null
  return <Icon className={className} />
}
